import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FieldType } from '@ngx-formly/core';
import { US_STATES, UsState } from '../../misc/us-states.const';

@Component({
  selector: 'app-formly-us-state',
  template: `
    <p-select
      [options]="states"
      optionLabel="name"
      [showClear]="true"
      [filter]="true"
      filterBy="name"
      dataKey="code"
      fluid="true"
      [placeholder]="props.placeholder ?? props.label"
      [formControl]="stateControl"
      [appendTo]="props['appendTo'] || null"
      styleClass="w-full"
    >
      <ng-template #selectedItem let-selectedOption>
        <div class="flex items-center" *ngIf="stateControl.value">
          <div>{{ stateControl.value.name }}</div>
        </div>
      </ng-template>
      <ng-template let-state #item>
        <div class="flex items-center gap-2">
          <span class="font-medium text-gray-500 w-8">{{ state.code }}</span>
          <div>{{ state.name }}</div>
        </div>
      </ng-template>
    </p-select>
  `,
  styles: [``],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyUsStateComponent extends FieldType implements OnInit {
  stateControl: FormControl = new FormControl();
  states: UsState[] = US_STATES;

  ngOnInit() {
    const selectedCode = this.formControl.value;
    if (selectedCode) {
      const selectedState = US_STATES.find(s => s.code === selectedCode);
      if (selectedState) {
        this.stateControl.setValue(selectedState);
      }
    }

    this.stateControl.valueChanges.subscribe(state => {
      this.formControl.setValue(state?.code ?? null);
    });
  }
}
